import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const privacyContent = `
Última actualización: Marzo 2026

En Cero Panza 14, nos comprometemos a proteger tu privacidad. Esta política describe cómo recopilamos, usamos y protegemos tu información personal.

**Información que recopilamos:**
• Nombre y dirección de correo electrónico al momento de la compra.
• Información de pago procesada de forma segura a través de terceros (no almacenamos datos de tarjetas).
• Datos de uso anónimos para mejorar nuestro servicio.

**Cómo usamos tu información:**
• Para enviarte el producto digital adquirido.
• Para enviarte actualizaciones relacionadas con tu compra.
• No vendemos, alquilamos ni compartimos tu información personal con terceros con fines de marketing.

**Protección de datos:**
• Utilizamos cifrado SSL para proteger la transmisión de datos.
• El acceso a tu información personal está restringido al personal autorizado.

**Tus derechos:**
• Podés solicitar la eliminación de tus datos en cualquier momento.
• Podés optar por no recibir comunicaciones de marketing.

**Cookies:**
• Utilizamos cookies esenciales para el funcionamiento del sitio y cookies analíticas para mejorar la experiencia del usuario.

Para cualquier consulta sobre privacidad, contactanos a través de nuestros canales oficiales.
`;
const termsContent = `
Última actualización: Marzo 2026

Al adquirir "Cero Panza 14", aceptás los siguientes términos y condiciones:

**Producto Digital:**
• "Cero Panza 14" es un producto de información digital en formato PDF.
• El acceso se otorga de forma inmediata tras confirmar el pago.
• El producto es para uso personal y no puede ser redistribuido, revendido ni compartido.

**Descargo de Responsabilidad Médica:**
• Este producto es solo para fines informativos y educativos.
• No reemplaza el consejo médico profesional, diagnóstico o tratamiento.
• Consultá siempre a tu médico antes de iniciar cualquier programa de alimentación o cambio en tu estilo de vida.
• Los resultados pueden variar de persona a persona.

**Política de Reembolso:**
• Debido a la naturaleza digital del producto, todas las ventas son finales.
• Si experimentás problemas técnicos para acceder al producto, contactanos y te ayudaremos.

**Propiedad Intelectual:**
• Todo el contenido de "Cero Panza 14" está protegido por derechos de autor.
• Queda prohibida la reproducción, distribución o modificación sin autorización expresa.

**Limitación de Responsabilidad:**
• No nos hacemos responsables por resultados individuales.
• El uso del producto es bajo tu propia responsabilidad.

**Modificaciones:**
• Nos reservamos el derecho de modificar estos términos en cualquier momento.
• Las actualizaciones serán comunicadas a través de nuestros canales oficiales.

Al completar tu compra, confirmás que leíste y aceptás estos términos.
`;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="bg-dark-bg border-t border-gray-800 py-8 px-4" data-id="element-22">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-23">
          <p className="font-inter text-gray-600 text-sm" data-id="element-24">
            © {new Date().getFullYear()} Cero Panza 14. Todos los derechos
            reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-25">
            <button onClick={() => setActiveModal('privacy')} className="font-inter text-gray-500 text-sm hover:text-brand-orange transition-colors" data-id="element-26">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-27">|</span>
            <button onClick={() => setActiveModal('terms')} className="font-inter text-gray-500 text-sm hover:text-brand-orange transition-colors" data-id="element-28">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-29">
          {/* Overlay */}
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-30" />

          {/* Modal content */}
          <div className="relative bg-dark-surface border border-gray-800 rounded-xl w-full max-w-2xl max-h-[80vh] shadow-2xl flex flex-col" onClick={e => e.stopPropagation()} data-id="element-31">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-800" data-id="element-32">
              <h2 className="font-oswald text-2xl font-bold text-white uppercase" data-id="element-33">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={closeModal} className="text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-34">
                <X className="w-6 h-6" data-id="element-35" />
              </button>
            </div>

            {/* Body */}
            <div className="p-6 overflow-y-auto flex-1" data-id="element-36">
              <div className="font-inter text-gray-300 text-sm leading-relaxed whitespace-pre-line" data-id="element-37">
                {activeModal === 'privacy' ? privacyContent : termsContent}
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-gray-800 text-center" data-id="element-38">
              <button onClick={closeModal} className="font-oswald text-sm uppercase tracking-wider text-brand-orange hover:text-white transition-colors font-bold" data-id="element-39">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </>;
}